import React, { useEffect } from 'react';
import PopUp from './PopUp';
import { usePopup, PopupType } from '../../Context/PopupContext';

const ChangelogPopup = () => {
    const { isPopupOpen, closePopup, closePopupIfType } = usePopup();
    const isOpen = isPopupOpen(PopupType.CHANGELOG);

    useEffect(() => {
        return () => closePopupIfType(PopupType.CHANGELOG);
    }, [closePopupIfType]);

    // Suggested format for the changelog
    const changelogData = [
        {
            date: 'June 7, 2026',
            title: '',
            platform: 'Android / iOS',
            type: 'feature',
            description: 'Added new search experience and article support'
        },
        {
            date: 'June 6, 2026',
            title: '',
            platform: 'Web',
            type: 'fix',
            description: 'Fixed an issue causing the Onboarding experience to repeatedly open.'
        },
        // {
        //     date: 'May 12, 2026',
        //     title: '',
        //     platform: 'Forum',
        //     type: 'fix',
        //     description: 'Fixed an issue preventing users from remaining logged in for any significant period of time.'
        // },
        {
            date: 'May 11, 2026',
            title: '',
            platform: 'Roku',
            type: 'feature',
            description: 'Added "Continue Watching" / "Favourites" carousels and the new search experience.'
        },
        {
            date: 'April 11, 2026',
            title: '',
            platform: 'Web',
            type: 'improvement',
            description: 'Re-enabled "Continue Watching", video progress is now saved as well.'
        },
        {
            date: 'March 22, 2026',
            title: '',
            platform: 'Web',
            type: 'feature',
            description: 'Search feature overhaul. The experience should be much faster and return more accurate results.'
        }
    ];

    if (!isOpen) return null;

    return (
        <PopUp
            isOpen={isOpen}
            onClose={closePopup}
            canBeDismissed={true}
            isFullScreen={true}
        >
            <div className="popup--changelog">
                <h2>Platform Updates</h2>
                <div className="changelog__list">
                    {changelogData.map((item, index) => (
                        <div key={index} className="changelog__item">
                            <div className="changelog__info-row">
                                <div className="changelog__info-row-inner">
                                    <p className="changelog__platform">{item.platform}</p>
                                    <p className={`changelog__tag ${item.type}`}>{item.type}</p>
                                </div>

                                <p className="changelog__date">{item.date}</p>
                            </div>

                            {/*<h3 className="changelog__title">*/}
                            {/*    {item.title}*/}
                            {/*</h3>*/}

                            <p>{item.description}</p>
                        </div>
                    ))}
                </div>
            </div>
        </PopUp>
    );
};

export default ChangelogPopup;
